export const getTruncatedText = (text: string, maxLength: number) => {
    if (text.length > maxLength) {
        const truncatedText = text.slice(0, maxLength);
        const trimmedText = truncatedText.trim();

        return `${trimmedText.slice(0, -1)}\u2026`;
    }

    return text;
};
